import { useEffect, useState, useCallback } from 'react';
import { toast } from '../components/ui/Toast';
import {
  syncPendingChanges,
  getPendingChanges,
  isOnline,
} from '../services/offlineCache';

export function useOfflineSync() {
  const [online, setOnline] = useState(isOnline());
  const [pendingCount, setPendingCount] = useState(0);

  // Update pending count
  const refreshPendingCount = useCallback(async () => {
    const changes = await getPendingChanges();
    setPendingCount(changes.length);
  }, []);

  const handleSync = useCallback(async () => {
    if (!isOnline()) return;

    const result = await syncPendingChanges(async (_change) => {
      // Placeholder: actual sync logic per change type would go here
      return true;
    });

    if (result.synced > 0) {
      toast({ title: `${result.synced}개 변경사항이 동기화되었습니다.`, variant: 'success' });
    }

    await refreshPendingCount();
  }, [refreshPendingCount]);

  useEffect(() => {
    const handleOnline = () => {
      setOnline(true);
      toast({ title: '온라인 상태로 전환되었습니다.', variant: 'success' });
      handleSync();
    };

    const handleOffline = () => {
      setOnline(false);
      toast({ title: '오프라인 상태입니다. 변경사항은 로컬에 저장됩니다.', variant: 'destructive' });
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    refreshPendingCount();

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [handleSync, refreshPendingCount]);

  return { online, pendingCount, handleSync, refreshPendingCount };
}
